import {gql} from '@apollo/client'

export const FINISH_CHILDCARE_REQUEST = gql`
  query finishChildcareRequest($employeeId: ID!) {
    client {
      employee(employeeId: $employeeId) {
        id
        staffCode
        displayFullName
        user {
          id
          email
        }
      }
    }
  }
`

export interface FinishChildcareRequestQueryVariables {
  employeeId: string
}

export interface FinishChildcareRequestQueryResult {
  client: {
    employee: Employee
  }
}

export interface Employee {
  id: string
  staffCode: string
  displayFullName: string
  user?: {
    id: string
    email: string
  }
}
